import type { ReactElement } from 'react';
import React from 'react';
import { HashLink } from 'react-router-hash-link';
import { markResponseHref } from 'pages/marking/helpers/presentation.helpers';

type Props = {
  hasComment: boolean;
  responseId: number;
  markId?: number;
};

export default function CommentLink({ hasComment, responseId, markId }: Props): ReactElement {
  return (
    <span>
      {markId && hasComment && (
        <HashLink to={`${markResponseHref(responseId, markId)}#commentSection`}>Y</HashLink>
      )}
      {markId && !hasComment && 'N'}
      {!markId && 'N/A'}
    </span>
  );
}
